<div id="showing-dateselect-container" class="prospect-grid-container">
  <form #scheduleTourForm="ngForm">
    <div id="showing-dateselect-top" class="tour-address">
    </div>
    <div id="showing-dateselect-cal-container">
      <h5>SELECT YOUR PREFERRED DATE:</h5>
      <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Tour Date</mat-label>
        <input matInput [matDatepicker]="selectedTourDate" name="selectedTourDate" id="tourDate" required [(ngModel)]="selectedDate" (dateChange)="dateSelected($event)" #TourDate="ngModel">
        <mat-datepicker-toggle matSuffix [for]="selectedTourDate"></mat-datepicker-toggle>
        <mat-datepicker #selectedTourDate ></mat-datepicker>
        <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
      </mat-form-field>
      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Time</mat-label>
        <mat-select name="tourTime" id="tourTime" required [(ngModel)]="selectedShowing" #TourTime="ngModel">
          <mat-option *ngFor="let show of showings let i = index" [value]="show">
            {{show.StartTimeString}}
          </mat-option>
        </mat-select>
        <mat-error>Please fill out this field</mat-error>
      </mat-form-field>      
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Desired Move In Date</mat-label>
        <input matInput [matDatepicker]="desiredMoveInPicker" name="desiredMoveInDate" id="desiredMoveInDate" required [(ngModel)]="prospectInfo.PreferredMoveIn" #DesiredMoveInDate="ngModel" >
        <mat-datepicker-toggle matSuffix [for]="desiredMoveInPicker"></mat-datepicker-toggle>
        <mat-datepicker #desiredMoveInPicker></mat-datepicker>
        <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
      </mat-form-field>
      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Household Monthly Gross Income</mat-label>
        <input matInput name="monthlyGrossIncome" id="monthlyGrossIncome" required
          [(ngModel)]="prospectInfo.IncomeAmount" #MonthlyGrossIncome="ngModel" numberCeilingRounder>
        <mat-error>Please fill out this field</mat-error>
      </mat-form-field>        
    </div>    
    </div>
    <div id="showing-dateselect-bottom">
      <div *ngIf="showingOptionCount!=null" class="alert alert-success"><span>{{showingOptionCount}} showing(s) are available for this date.</span></div>
    </div>
    <div *ngIf="showLoader" class="flex justify-center"><mat-progress-spinner
      mode="indeterminate"></mat-progress-spinner>
      Getting Available Times....
  </div>       
  <div id="showing-dateselect-bottom-btn">
        <button mat-flat-button color="primary" class=" w-full my-4 font-normal text-2xl sm:text-base" [disabled]="showingOptionCount === null || showingOptionCount === 0 || !scheduleTourForm.form.valid" (click)="onSubmit()">NEXT</button>
    </div>
  </form>
</div>


